import Collapse from '@components/Collapse'
import Select from '@components/Select'
import WithLearningPathContext, { WithLearningPathContextProps } from '@hocs/WithLearningPathContext'
import FlexChapter from '@layouts/LearningPath/Chapter/Flex'
import CollapseHeader from '@layouts/LearningPath/Layout/CollapseHeader'
import { PanelPathProps } from '@layouts/LearningPath/Layout/PanelPath'
import { SelectWrapper, TileCol, TileRow } from '@layouts/LearningPath/Layout/style'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

const PanelCulture: React.FC<PanelPathProps & WithLearningPathContextProps> = ({
  Path,
  activeId,
  setActive,
  setActiveHover,
}) => {
  const langOptions = Object.keys(Path?.CultureUnitsLanguages ?? {}).map((lang) => ({
    label: Path?.CultureUnitsLanguages[lang],
    value: lang,
  }))
  const [activeLang, setActiveLang] = useState(langOptions[0]?.value)
  const intl = useIntl()

  if (!Path?.IsFlex || !Path?.CultureUnits?.length) {
    return null
  }

  return (
    <Collapse.Panel
      id={`${Path.Id.toString()}-culture`}
      header={<CollapseHeader title={intl.formatMessage({ id: 'Culture' })} />}
    >
      <SelectWrapper>
        <Select
          label=""
          name="Program"
          value={activeLang}
          onChange={(lang) => {
            setActiveLang(lang)
          }}
          options={langOptions}
          disableMargin
          responsive
        />
      </SelectWrapper>
      <TileRow id="scroller">
        {Path.CultureUnits?.map((Unit) => (
          <TileCol
            id={`tile-${Unit.Id}`}
            onClick={() => setActive(Unit.Id)}
            onMouseOver={() => setActiveHover(Unit.Id)}
            onMouseLeave={() => setActiveHover(0)}
            key={Unit.Id}
          >
            <FlexChapter Unit={Unit} active={activeId === Unit.Id} bridgeless selectedLanguage={activeLang} />
          </TileCol>
        ))}
      </TileRow>
    </Collapse.Panel>
  )
}

export default WithLearningPathContext(React.memo(PanelCulture))
